import React, {useState, useEffect} from 'react';
import {useDropzone} from 'react-dropzone';
import { IconButton, FormControl, FormLabel, Input, Typography } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import UploadIcon from '@mui/icons-material/Upload';
import { Controller } from "react-hook-form";


const img = {
  display: 'block',
  width: 'auto',
  height: '100%'
};

const thumbContainer = {
  display: 'flex', 
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
}


export default function ImageUpload({name, control, errors, question, required, setValue}) {
  const [files, setFiles] = useState([]);
  const [touched, setTouched] = useState(false)

  const {getRootProps, getInputProps, fileRejections, acceptedFiles, open} = useDropzone({
    accept: {
      'image/*': []
    },
    multiple: false,
    maxSize: 10000000,
    onDrop: acceptedFiles => {
      setFiles(acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file),
      })));
    },
    noClick: true,
    noKeyboard: true,
  });
  
  const removeFile = (file) => {
    const newFiles = [...files]
    newFiles.splice(newFiles.indexOf(file), 1)
    setFiles(newFiles)
  }

  const fileRejectionItems = fileRejections.map(({ file, errors  }) => { 
    return (
      <li key={file.path}>
           <ul>
             {errors.map(e => <li key={e.code}>{e.message}</li>)}
          </ul>
      </li>
    ) 
   });

  useEffect(() => {
    return () => files.forEach(file => URL.revokeObjectURL(file.preview));
  }, []);

  useEffect(() => {
    if (acceptedFiles.length !==0 && !touched) {setTouched(true)}
  }, [acceptedFiles])

  useEffect(() => {
    setValue(name, files, {shouldValidate: touched});
  }, [files, touched, name, setValue]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={""}
      render={({ field }) =>
      <FormControl fullWidth error={errors? true : false}>
          <FormLabel required={required}>{question}</FormLabel>
              <div className="dropzone-box">
                {files.length !== 0 ?
                  <div style={thumbContainer}>
                    {files.map(file => (
                        <div className='thumb' key={file.name}>
                          <img
                            src={file.preview}
                            style={img}
                            onLoad={() => { URL.revokeObjectURL(file.preview) }}
                          />
                          <IconButton size="small" onClick={removeFile}>
                            <DeleteIcon/>
                          </IconButton>
                        </div>
                    ))}
                  </div> :
                  <div {...getRootProps({className: 'col-center font-14'})} onClick={open}>
                    <input 
                    {...getInputProps()} />
                    <UploadIcon/>
                    <div>Choose file OR Drag here</div>
                    <div>Size Limit: 10MB</div>
                  </div>
                }
              </div>
          <Typography className="font-14 error-message">
          {errors?.message || fileRejectionItems}
          </Typography>
      </FormControl>}
      />
  );
}